import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { t } from '../../lib/i18n';
import ModalDialog from '../../components/modal-dialog';
import RewardsList from './rewards-list';
import ContactForm from './contact-form/contact-form';
import Imprint from './imprint/imprint';

class StatusOverview extends Component {
    constructor() {
        super();
        this.state = { };
        this.setState({
            imprintVisible: false,
            reward: null,
        });
    }

    renderContactForm() {
        return (<ModalDialog
          isVisible={!!this.state.reward}
          isKeyboardShown={this.state.isKeyboardShown}
          onClose={() => this.setState({ reward: null })}
          className="contact-form"
        >
            <ContactForm
              installId={this.props.installId}
              reward={this.state.reward}
              baseUrl={this.props.baseUrl}
              onClose={() => this.setState({ reward: null })}
              onGoToOfferButtonClicked={() => this.props.onClose()}
              onInputFocus={() => this.setState({ isKeyboardShown: true })}
              onInputBlur={() => this.setState({ isKeyboardShown: false })}
            />
        </ModalDialog>);
    }

    renderImprint() {
        return (<ModalDialog
          isVisible={!!this.state.imprintVisible}
          onClose={() => this.setState({ imprintVisible: false })}
          dialogClassName="imprint"
        >
            <Imprint />
        </ModalDialog>);
    }

    render() {
        return (
            <div className={this.props.className}>
                <h1>{t('statusOverview.title')}</h1>

                {(() => {
                    if (this.props.statusData) {
                        const rewards = this.props.statusData;
                        if (!rewards || !rewards.length) {
                            return <p className="subtle">{t('statusOverview.rewardsListEmpty')}</p>
                        }
                        return (<RewardsList
                          rewards={rewards}
                          onRewardSelected={reward => this.setState({ reward })}
                        />);
                    }
                    return (<div className="loading">Loading…</div>);
                })()}

                <button
                  className="imprint-button"
                  onClick={() => this.setState({ imprintVisible: true })}
                >
                    {t('contactForm.imprintButtonLabel')}
                </button>

                {this.renderContactForm()}
                {this.renderImprint()}
            </div>
        );
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
StatusOverview.propTypes = {
    installId: PropTypes.string,
    onClose: PropTypes.func,
    statusData: PropTypes.array.isRequired,
    baseUrl: PropTypes.string.isRequired,
};


const StyledStatusOverview = styled(StatusOverview)`
    section.rewards-list > header {
        margin-top: 1em;
        font-weight: bold;
    }
    ul.rewards {
        display: inline-block;
        width: 100%;
    }
    ul.rewards > li {
        padding: 1em 0;
        list-style-type: none;
        text-align: center;
    }
    ul.rewards > li footer {
        text-align: right;
    }
    ul.rewards > li .action-button {
        padding: 0.25em 0.5em;
        background-color: #ada8a0;
        margin-top: 0.5em;
        margin-bottom: 0;
        font-size: 0.75em;
        font-weight: normal;
    }
    ul.rewards > li + li {
        border-top: 1px solid rgba(0,0,0,0.1);
    }
    button.action-button {
        clear: both;
        padding: 0.5em 1em;
        margin-bottom: 1em;
        cursor: pointer;
    }
    .imprint-button {
        margin-top: 1em;
        background-color: transparent !important;
        color: rgba(0,0,0,0.5) !important;
        cursor: pointer;
    }
`;


export default StyledStatusOverview;



// WEBPACK FOOTER //
// ./src/pages/status-overview/status-overview.jsx